//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

let constainer_top = null
export default {
    props: {
        zones:  Array,
        selected: Object
    },
    data () {
        return {
            show_dlg: false
        }
    },
    methods: {
        checkPosition () {
            const query = this.$mp.component.createSelectorQuery()
            query.select('#zone-selector').boundingClientRect()
            query.exec((res) => {
                if (res.length && res[0] && res[0].top > 10) {
                    constainer_top = res[0].top
                    this.resetScroll()
                }
            })
        },
        resetScroll () {
            console.error(constainer_top)
            if (constainer_top === null) {
                this.checkPosition()
            } else {
                wx.pageScrollTo({
                    scrollTop: constainer_top
                })
            }
        },
        toggleDlg () {
            if (!this.show_dlg) {
                this.resetScroll()
            }
            this.show_dlg = !this.show_dlg
        },
        onSelect (zone) {
            this.$emit('change', zone)
            this.resetScroll()
            this.toggleDlg()
        }
    }
}
